/* Bed Choices — add-on handling in the cart.
 * An add-on line (e.g. Split Headboards) names its bed in its visible "For:" note,
 * e.g. "For: Anna Ottoman Bed – 4"6 Double / 60" Floor Standing Headboard / Right Open".
 * No hidden properties are used. The rule: never more of an add-on than the beds
 * it's for. Removing the bed removes its add-ons; reducing the bed's quantity
 * reduces them to match. Raising the bed's quantity does not add add-ons.
 * Works on the cart page and the drawer; re-runs whenever either re-renders.
 */
(function () {
  'use strict';

  var FOR_KEY = 'For';

  var busy = false;
  var reloading = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Compare names loosely: case, spacing, dash and quote styles don't matter. */
  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/[\u2018\u2019\u2032]/g, "'")
      .replace(/[\u201C\u201D\u2033]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function forOf(item) {
    var value = (item.properties || {})[FOR_KEY];
    return value ? norm(value) : null;
  }

  /* The same "Product – Variant" text the builder writes into the For note. */
  function nameOf(item) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' – ' + item.variant_title : '';
    return norm(item.product_title + variant);
  }

  /* Visually mark add-on lines so they read as part of the bed above them. */
  function decorate(cart) {
    cart.items.forEach(function (item) {
      if (!forOf(item)) return;
      var key = item.key;
      var selectors = [
        '[data-bc-line-key="' + key + '"]',
        '[data-key="' + key + '"]',
        '[id*="' + key + '"]',
        'tr[data-cart-item-key="' + key + '"]'
      ];
      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var row = el.closest('tr, .cart-item, .cart-drawer-item') || el;
          row.classList.add('bc-cart-addon');
        });
      });
    });
  }

  /* Cap each add-on at the quantity of the beds it's for (0 if the bed is gone). */
  function enforce(cart) {
    if (busy || reloading) return Promise.resolve();

    var bedQty = {};
    cart.items.forEach(function (item) {
      if (forOf(item)) return; // add-ons aren't beds
      var name = nameOf(item);
      bedQty[name] = (bedQty[name] || 0) + item.quantity;
    });

    var groups = {};
    cart.items.forEach(function (item) {
      var target = forOf(item);
      if (!target) return;
      // Group by add-on product and the bed it's for.
      var id = item.product_id + '|' + target;
      (groups[id] = groups[id] || { target: target, lines: [] }).lines.push(item);
    });

    var updates = {};
    Object.keys(groups).forEach(function (id) {
      var group = groups[id];
      var allowed = bedQty[group.target] || 0;
      group.lines.forEach(function (line) {
        var keep = Math.min(line.quantity, allowed);
        allowed -= keep;
        if (keep !== line.quantity) updates[line.key] = keep;
      });
    });

    if (!Object.keys(updates).length) return Promise.resolve();

    busy = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        busy = false;
        reloading = true;
        window.location.reload();
      })
      .catch(function () {
        busy = false;
      });
  }

  function run() {
    if (reloading) return;
    getCart()
      .then(function (cart) {
        decorate(cart);
        return enforce(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('bc:cart:updated', run);
  document.addEventListener('cart:refresh', run);
  document.addEventListener('shopify:section:load', run);

  /* Themes that swap cart HTML without firing an event. */
  var container = document.querySelector('#main-cart-items, cart-drawer, .cart-drawer, #CartDrawer');
  if (container && 'MutationObserver' in window) {
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 250);
    }).observe(container, { childList: true, subtree: true });
  }
})();
